<template>
	<figure class="external-ad-image-figure">
		<a v-if="ad.hyperlink" :href="ad.hyperlink" class="external-ad-image-wrapper">
			<img :src="ad.image" :style="{height: `${height}px`, width: 'auto'}">
		</a>
		<div v-else class="external-ad-image-wrapper">
			<img :src="ad.image" :style="{height: `${height}px`, width: 'auto'}">
		</div>
	</figure>
</template>

<script>
	export default {
		name: "ExternalAd",
		props: {
			ad: {
				type: Object,
				required: true
			},
			height: {
				type: Number,
				required: true,
			}
		},
	}
</script>

<style lang="scss" scoped>
	figure.external-ad-image-figure {
		display: inline-block;
		margin: 0 0.25rem 0.25rem;

		img:hover {
			filter: contrast(2);
		}
	}
	.external-ad-image-wrapper {
		display: inline;
	}
</style>